export default __webpack_public_path__ + "static/anilPokhriyal9-52e3f2085922d1af702ffb5c8b4d75dd.jpg";